<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5wEsOX/tc-custom/9781429971447.jpg?1730578550565" alt="This image is the cover for the book Lost King of France"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost King of France
      </h1>
      <p class="bookDescription body article font2">
        <b>“Cadbury lays out in fascinating detail the historical mystery of the royal heir . . . and uses modern science to try to solve it.” —<i>The Wall Street Journal</i></b><br/><br/>In 1793, when Marie Antoinette was beheaded at the guillotine during the French Revolution, she left her adored eight-year-old son, Louis Charles, imprisoned in the Temple Tower. Far from inheriting a throne, the orphaned boy-king had to endure the hostility and abuse of a nation. Two years later, the revolutionary leaders declared Louis XVII dead. No grave was dug, no monument built to mark his passing.<br/><br/>Immediately, rumors spread that the prince had, in fact, escaped from prison and was still alive. Others believed that he had been murdered, his heart cut out and preserved as a relic. As with the tragedies of England’s princes in the Tower and the Romanov archduchess Anastasia, countless “brothers” soon approached Louis-Charles’s older sister, Marie-Therese, who survived the revolution. They claimed not only the dauphin’s name, but also his inheritance. Several “princes” were plausible, but which, if any, was the real heir to the French throne?<br/><br/><i>The Lost King of France</i> is a moving and dramatic tale that interweaves a pivotal moment in France’s history with a compelling detective story that involves pretenders to the crown, royalist plots and palace intrigue, bizarre legal battles, and modern science. The quest for the truth continued into the twenty-first century, when, thanks to DNA testing, the strange odyssey of a stolen heart found within the royal tombs brought an exciting conclusion to the two-hundred-year-old mystery of the lost king of France.<br/><br/><b>“A winning and highly readable account of the French Revolution.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Cadbury
      </h2>
      
      <p class="authorDescription body article"><P><B>Deborah Cadbury</B> is an award-winning journalist specializing in the fundamental issues of science and history and their effects on today's society.  She is also the author of the highly acclaimed books <I>Terrible Lizard</I> and <I>The Estrogen Effect</I>. She has produced science programs for BBC television and has won numerous international science film awards, including an Emmy. She lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?446a3ee9